import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { GatewayTokenModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/tokens/models/outputs/gateway-token.model';
import { CellContext } from '@tanstack/react-table';

export interface TokenListFullNameCellProps
  extends CellContext<GatewayTokenModel, GatewayTokenModel['firstName']> {}

export const TokenListFullNameCell = (
  props: TokenListFullNameCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { row } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  if (!row.original.firstName && !row.original.lastName) {
    return <Text>-</Text>;
  }

  return (
    <Text>
      {row.original.firstName} {row.original.lastName}
    </Text>
  );
};
